export interface RadioGroupChangeEventDetail {
  checked: boolean;
  value?: string;
  componentId?: string;
}

